'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.weeksFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/weeksFromNow.js
// module id = 755
// module chunks = 0